export const SignUp_REQUEST = "SignUp_REQUEST"
export const SignUp_SUCCESS = "SignUp_SUCCESS"
export const SignUp_FAILURE = "SignUp_FAILURE"